import { svg } from "lit";
const icon = svg `<path d="M11.8719 13.7121L11.0978 12.9541L13.5097 10.5422H4.41675V9.45894H13.5097L11.0978 7.04706L11.8719 6.28906L15.5834 10.0006L11.8719 13.7121Z" fill="currentColor"/>`;
export default icon;
